import React from "react";
import { SignalBadge } from "./SignalBadge";
import { TrendingUp, TrendingDown } from "lucide-react";

export const ProbabilityWidget = ({ signal }) => {
    const up = signal.prob_up ?? 50;
    const down = signal.prob_down ?? 50;

    return (
        <div data-testid="probability-widget" className="border border-soft bg-elev p-4">
            <div className="text-[10px] text-mute tracking-widest mb-3">PROBABILITÀ DIREZIONE</div>

            {/* Bar */}
            <div className="relative h-3 bg-elev2 overflow-hidden mb-3">
                <div
                    className="absolute inset-y-0 left-0"
                    style={{ width: `${up}%`, background: "var(--green)" }}
                />
                <div
                    className="absolute inset-y-0 right-0"
                    style={{ width: `${down}%`, background: "var(--red)" }}
                />
            </div>

            <div className="grid grid-cols-2 gap-2 mb-4">
                <div data-testid="prob-up" className="text-left">
                    <div className="flex items-center gap-1 text-[10px] text-mute tracking-widest">
                        <TrendingUp size={11} style={{ color: "var(--green)" }} /> SALITA
                    </div>
                    <div className="text-2xl font-bold tnum" style={{ color: "var(--green)" }}>{up}%</div>
                </div>
                <div data-testid="prob-down" className="text-right">
                    <div className="flex items-center justify-end gap-1 text-[10px] text-mute tracking-widest">
                        DISCESA <TrendingDown size={11} style={{ color: "var(--red)" }} />
                    </div>
                    <div className="text-2xl font-bold tnum" style={{ color: "var(--red)" }}>{down}%</div>
                </div>
            </div>

            <div className="border-t border-soft pt-3">
                <div className="text-[10px] text-mute tracking-widest mb-2">CONSIGLIO</div>
                <SignalBadge action={signal.action} confidence={signal.confidence} size="lg" />
                <div className="text-[10px] text-mute mt-2 tnum">
                    Score {signal.score} · Confidence {signal.confidence}%
                </div>
            </div>
        </div>
    );
};
